<bindable name="year"></bindable>

<footer>
	<div class="container">
		<ul class="footer-nav">
			<li>${year} &copy; IA Online Quoting by<a href="https://www.iaanyware.net" external target="_blank"> iaAnyware Pty Limited</a></li>
		</ul>
		<div class="footer-branding">
			<p>powered by</p>
			<a href="https://insuranceadviser.net" target="_blank" external><img src.bind="$parent.footerLogo" alt="Insurance Advisernet"><a>
			<a href="https://insuranceadviser.net/ia-privacy-policy" external target="_blank">Privacy</a>
		</div>
	</div>
	<div class="container" style="margin-top: 2.5rem">
		<div class="footer-branding">
			<p>Association Insurance Australia Pty Ltd trading as Veterinary Insurance Australia is a Corporate Authorised Representative (no. 1239023) of Insurance Advisernet Australia Pty Ltd, AFSL 240549</p>
		</div>
	</div>
</footer>